import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-input-box" }
const _hoisted_2 = { class: "form-input-line" }
const _hoisted_3 = ["placeholder", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "validator-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.text) = $event)),
        class: _normalizeClass(['form-input',$props.validator && !$props.isDisabled ? 'form-input-validate':'']),
        placeholder: $props.placeholder,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onInputChanged && $setup.onInputChanged(...args))),
        disabled: $props.isDisabled
      }, null, 42, _hoisted_3), [
        [_vModelText, $setup.text]
      ]),
      ($props.validator && !$props.isDisabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.TUITranslateService.t("AIDesk.请填写必填项")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}